"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ReactGoogleAutocomplete.default;
  }
});
Object.defineProperty(exports, "usePlacesWidget", {
  enumerable: true,
  get: function get() {
    return _usePlacesWidget.default;
  }
});
var _ReactGoogleAutocomplete = _interopRequireDefault(require("./ReactGoogleAutocomplete"));
var _usePlacesWidget = _interopRequireDefault(require("./usePlacesWidget"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}